import ERC20 from './ERC20.json'
import ownableAbi from './ownable.json'
import swaptokenAbi from './swaptoken.json'
import mintAbi from './mint.json'
import bidAbi from './bid.json'

export const abis = {
  ERC20,
  ownable: ownableAbi,
  swaptoken: swaptokenAbi,
  mint: mintAbi,
  bid: bidAbi,
}

export default abis;
